import theme from "@/theme";

const BluePlusSvg = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.8241 7.99988H3.1759"
      stroke={theme.palette.custom.mainBlue}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.5 2.67578V13.324"
      stroke={theme.palette.custom.mainBlue}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default BluePlusSvg;
